module.exports = __webpack_public_path__ + "img/ea.6ed3cad7.png";